import { useRef } from "react";
import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { Tag } from "../../types/tag";
import LocalePs from "../locale/localePs.core";
import localeCore from "../../core/locale.core";
import Link from "next/link";
import DeleteTagDialog from "./deleteTag.comp";
import Toggle from "../reuseables/toggle.core";
import PencilIcon from "../../icons/pencil.icon";
import { useQueryClient } from "@tanstack/react-query";
import { post } from "../../core/fetch.core";
import DeleteIcon from "../../icons/delete.icon";
import MagnifyingIcon from "../../icons/magnifying.icon";

export default function TagRow({ tag }: { tag: Tag }) {
  const { selectedShop } = useShop();
  const { t, msg } = useTranslation();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const queryClient = useQueryClient();
  async function clickDelete() {
    dialogRef.current?.showModal();
  }

  async function enableCategory(enabled: boolean) {
    await post("/admin/tag/setEnable", {
      id: tag.id,
      enabled,
    });

    queryClient.invalidateQueries({ queryKey: ["tag"] });
  }

  if (!selectedShop) return null;

  return (
    <div
      attr-name={localeCore.getLocaleValueDefault(tag.name)}
      attr-type="tag-row"
      className={`grid grid-cols-[100px_auto] lg:grid-cols-[3fr_3fr_2fr_1fr] gap-x-12 gap-y-3 px-6 py-6 border-t-[1px] text-sm dark:text-white group/edit`}
    >
      <div>
        <LocalePs value={tag.name} />
      </div>
      <div>
        <LocalePs value={tag.slug} />
      </div>
      <div className="flex items-center">
        <Toggle
          title=""
          isChecked={tag.enabled}
          onChange={(isChecked: boolean) => {
            enableCategory(isChecked);
          }}
        />
        <Link className="catgory-edit cursor-pointer" href={`tag/edit/?id=${tag.id}`}>
          <PencilIcon className="w-4 h-4" />
        </Link>
      </div>
      <div className="flex items-center gap-4">
        <Link className="tag-edit cursor-pointer underline leading-8" href={`tag/edit/${tag.id}`}>
          <PencilIcon className="w-4 h-4" />
        </Link>
        <Link
          className="tag-edit cursor-pointer underline leading-8"
          href={{ pathname: `tag/${tag.slug.en}`, query: { id: tag.id } }}
        >
          <MagnifyingIcon className="w-4 h-4" />
        </Link>
        <button className="tag-edit cursor-pointer underline  text-red-600" type="button" onClick={clickDelete}>
          <DeleteIcon className="w-4 h-4" />
        </button>
        <DeleteTagDialog dialogRef={dialogRef} tagId={tag.id} />
      </div>
    </div>
  );
}
